// Shared helper for displaying the best-available address string on a location.
// Prefers the new country-aware formatted_address, falls back to the legacy address column.
export function getDisplayAddress(loc) {
  return loc?.formatted_address || loc?.address || "";
}
